import React from "react";
import { OfferLink } from "./OfferLink";
import { CtaMicrocopy } from "./CtaMicrocopy";
import { CollectionMockup } from "./CollectionMockup";
import { ctaMicrocopy, productVisuals } from "../data/offer";
import { heroBenefits } from "../data/landing";
export function Hero() {
  return <section className="bg-canvas" data-id="element-112" data-mp="4m8nyh6uizn1">
      <div className="mx-auto grid max-w-6xl gap-x-12 px-5 pb-16 pt-10 md:pt-14 lg:grid-cols-[1.05fr_1fr] lg:pb-24 lg:pt-16" data-id="element-113" data-mp="4n1oh0f7oswq">
        <div className="text-center lg:col-start-1 lg:text-left" data-id="element-114" data-mp="127ect9b6vhbc">
          <p className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-gold-deep md:text-[13px]" data-id="element-115" data-mp="xbpaiy7sbmbc">
            For Christian Parents of Kids Ages 8–14
          </p>
          <h1 className="mt-4 font-display text-[2.1rem] font-extrabold leading-[1.08] tracking-tight text-ink sm:text-5xl lg:text-[3.35rem]" data-id="element-116" data-mp="nb6ktmtjhbli">
            Build an <span className="text-royal" data-id="element-117" data-mp="3cz5w0drpe41e">Unshakable</span> Foundation of Faith in Your Child Before It's Too Late.
          </h1>
        </div>

        <div className="mt-8 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:mt-0 lg:self-center" data-id="element-118" data-mp="3j893b0s41pjq">
          <CollectionMockup src={productVisuals.heroMockup} data-id="element-119" data-mp="3o7vhbcfrj9tl" />
        </div>

        <div className="mt-8 text-center lg:col-start-1 lg:mt-6 lg:text-left" data-id="element-120" data-mp="39al8ybyf2k23">
          <p className="text-lg leading-relaxed text-ink-soft" data-id="element-121" data-mp="39cpa4m4xl4yo">
            Your child may know every Bible story, memorize Scripture, and attend Sunday School every week.
          </p>
          <p className="mt-2 text-lg font-semibold leading-relaxed text-ink" data-id="element-122" data-mp="30fy9rxjcj3ya">
            But will they know <span className="text-royal" data-id="element-123" data-mp="35aubxqiar7p4">WHY</span> they believe when someone challenges their faith?
          </p>
          <p className="mt-4 leading-relaxed text-ink-soft" data-id="element-124" data-mp="2qi0o9hsvfl9d">
            Discover <strong className="font-bold text-ink" data-id="element-125" data-mp="2vj7tb93mq6cc">WHY WE BELIEVE</strong> — a complete digital collection
            designed to help children explore the reasons behind Christian faith, understand difficult questions, and
            learn to think, not just repeat.
          </p>

          <p className="mt-6 rounded-2xl bg-gold-light px-5 py-3.5 font-display text-base font-bold text-navy md:text-lg" data-id="element-126" data-mp="s2tcpjbm05oo">
            Real Questions. Meaningful Reasons. A Stronger Foundation for Faith.
          </p>

          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 font-display text-sm font-bold text-navy lg:justify-start" data-id="element-127" data-mp="ichwaxaqo40w">
            {heroBenefits.map((item, i) => <li key={item} className="flex items-center gap-3" data-id="element-128" data-mp="1b04bz3x8qz44" data-mpi={i}>
                {i > 0 && <span aria-hidden="true" className="text-gold-deep" data-id="element-129" data-mp="16346au4azydj">•</span>}
                {item}
              </li>)}
          </ul>

          <div className="mt-7 max-w-lg lg:max-w-md mx-auto lg:mx-0" data-id="element-130" data-mp="114kfogerlyeu">
            <OfferLink label="Yes! I Want Instant Access" data-id="element-131" data-mp="x0uwk6gv0917" />
            <CtaMicrocopy items={ctaMicrocopy.hero} align="start" data-id="element-132" data-mp="3lt774vhctzwd" />
          </div>
        </div>
      </div>
    </section>;
}